import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import vuetify from './plugins/vuetify'
import { store } from './store'
// import { APP_VERSION } from './version';

import VueGeolocation from 'vue-browser-geolocation'
import "./plugins/echarts";
// import axios from "axios";
import VueBarcodeScanner from 'vue-barcode-scanner'

/* Import the firebase SDK and extend with firestore */
import firebaseApp, { messaging, auth, database, firestore, storage } from '../firebase-init';
// // import firebase from 'firebase';
// import firebase from 'firebase/app';
// import 'firebase/auth';
// import 'firebase/database';
// import 'firebase/messaging';
// // require('firebase/firestore');
// import 'firebase/firestore';
// import 'firebase/storage';

Vue.config.productionTip = false

// const configOptions = {
//   apiKey: "AIzaSyATi5dFAjcKUvby5Dokwe2eVQbTA6JqJAw",
//   authDomain: "facts-skymat.firebaseapp.com",
//   databaseURL: "https://facts-skymat.firebaseio.com",
//   projectId: "facts-skymat",
//   storageBucket: "facts-skymat.appspot.com",
//   messagingSenderId: "574529435174",
//   appId: "1:574529435174:web:10c11b3c47bd4998af98e7"
// };

import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import Clipboard from 'v-clipboard';


// // firebase.initializeApp(firebaseConfig);
// firebase.initializeApp(configOptions);
// Vue.prototype.$firebase = firebase;

// // Initialize Firebase Messaging
// const messaging = firebase.messaging();
// messaging.usePublicVapidKey('BKF4lA9KeQslzkwuwxFCiToNh5ak7dsk0JVCWzOMLEKD_8AfgWdMcGNVrk20KTdQ8RhyScHS3_tKlw38fS9PsNM');

// // Initialize Firestore
// const db = firebase.firestore();
// const fbStorage = firebase.storage();


// Vue.prototype.$messaging = messaging;
// Vue.prototype.$db = db;
// Vue.prototype.$fbStorage = fbStorage;

Vue.use(VueGeolocation)
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    key :'AIzaSyDFIf6b6PeZHNQC_mX1u27fDsqV9_rvh6k',
    libraries:'places,directions',
    version: "weekly",
    callback: 'initMap', 

    // key: 'AIzaSyD-IKpgWVUY3eBgB8Yl5tGvPlvu-E7g0n0'
  }
})

const toastOptions = {
  position: 'top-right',
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: 'button',
  icon: true,
  rtl: false
};

const barcodeScanneroptions = {
  sound: true, 
  soundSrc: '/static/store-scanner-beep-90395.wav', 
  sensitivity: 300, 
  requiredAttr: true, 
  controlSequenceKeys: ['NumLock', 'Clear'] 
}

Vue.prototype.$firebase = firebaseApp;
Vue.prototype.$messaging = messaging;
Vue.prototype.$auth = auth;
Vue.prototype.$database = database;
Vue.prototype.$firestore = firestore;
Vue.prototype.$storage = storage;

Vue.use(Toast, toastOptions);
Vue.use(VueSweetalert2);
Vue.use(Clipboard);
Vue.use(VueBarcodeScanner, barcodeScanneroptions)
Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  store,
  // firebase,
  render: h => h(App),
}).$mount('#app')


// export default configOptions;


// console.log(`Version: ${APP_VERSION}`);
// // Your web app's Firebase configuration
// const firebaseConfig = {
//   apiKey: "AIzaSyBke-rBMgbER65J5Syg9rdIWQOmwxpf66o",
//   authDomain: "facts-triton.firebaseapp.com",
//   projectId: "facts-triton",
//   storageBucket: "facts-triton.appspot.com",
//   messagingSenderId: "4546380777",
//   appId: "1:4546380777:web:cc9655a8e5edcb3ac78178"
// };
// console.log("1");
// Function to get URL parameters
// const  getQueryParam = (param) => {
//   const queryString = window.location.search;
//   const urlParams = new URLSearchParams(queryString);
//   console.log("urlParams",urlParams);
//   const result = urlParams.get(param);
//   console.log("urlParamsresult",result);
//   return result;
// }
// console.log("2");
// // Check for 'restart' parameter and clear localStorage if it's 'true'
// if (getQueryParam('restart') === 'true') {
//   console.log("clearing local storage")
//   // localStorage.clear();

//   // Change the URL to remove the 'restart' query parameter
//   const newUrl = window.location.href.split('?')[0];
//   window.history.replaceState(null, null, newUrl);
  
//   // Important: Use nextTick to ensure the reload happens after Vue initialization
//   Vue.nextTick(() => window.location.reload(true));
  
//   // Force reload from the server, bypassing the cache
//   // window.location.reload(true);
// }
// localStorage.clear();
// sessionStorage.clear();


// const isCriticalError = (error) => {
//   // Check if error message contains a specific string
//   if (error.message.includes("Critical Error")) {
//     return true; // Reload the app
//   }

//   // Or check the error name
//   if (error.name === "SyntaxError") {
//     return true; // Reload the app
//   }

//   return false; // Do not reload the app
// };

// Vue.config.errorHandler = function (err, vm, info) {
//   console.error('Caught global error:', err);
//   console.error('Caught global error:', vm);
//   console.error('Caught global error:', info);
//   if (isCriticalError(err)) {
//     window.location.href = '/fallback.html';
//   } else {
//     localStorage.clear();
//     sessionStorage.clear();
//     location.reload();
//   }
// };
// navigator.serviceWorker.register('firebase-messaging-sw.js')
//   .then((registration) => {
//     console.log('Service Worker Registered', registration);
//     messaging.useServiceWorker(registration);
//   });
